<template>
  <t-default-layout active-nav-id="announcements">
    <div :class="componentClassName">
      <a-back-page text="一覧画面" page="Announcements" />
      <form
        ref="form"
        class="t-announcements-add__form"
        enctype="multipart/form-data"
        @submit.prevent="handleFormSubmit"
      >
        <div class="t-announcements-add__fields">
          <m-section>
            <m-action-card :id="idName[0]" title="お知らせコンテンツ登録" header-border no-header-margin icon="clock">
              <div class="t-announcements-add__fields__pushtype">
                <m-form-input id="t-announcements-add-info-importantFlag__form-input">
                  <a-text id="t-announcements-add__fields__a-text-top_1">●</a-text>
                  <a-text id="t-announcements-add-info-importantFlag__a-text">重要なお知らせ</a-text>　　
                  <a-switch
                    id="t-announcements-add-importantFlag"
                    v-model="announcementData.importantFlag"
                    data-testid="add-announcement-important-toggle-button"
                    @change="checkDefaultCategory"
                  />
                </m-form-input>
                <m-form-input id="t-announcements-add__fields__pushtype_1">
                  <a-text id="t-announcements-add__fields__a-text-top_2">●</a-text>
                  <a-text id="t-announcements-add__fields__pushtype__a-text">通知ステータス</a-text>
                  <a-select-field
                    id="t-announcements-add__fields__pushtype__a-select-field"
                    v-model="pushStatus"
                    :options="pushStatusOptions"
                  />
                </m-form-input>
                <m-form-input v-if="pushStatus !== 'none'" id="t-announcements-add__fields__pushnotificationcategory">
                  <a-text id="t-announcements-add__fields__a-text-top_2">●</a-text>
                  <a-text>プッシュ通知カテゴリ選択</a-text>
                  <a-select-field
                    v-model="announcementData.pushNotificationCategory"
                    :options="pushNotificationCategoryOptions"
                  />
                </m-form-input>
              </div>
              <div v-if="pushStatus !== 'none'" class="t-announcements-add__fields__pushcategory">
                <m-form-input id="t-announcements-add-info-pushcategory__form-input">
                  <a-text id="t-announcements-add__fields__pushcategory__a-text-top">●</a-text>
                  <a-text id="t-announcements-add__fields__pushcategory__a-text">プッシュ通知タイトルタグ</a-text>
                  <div id="t-announcements-add__fields__pushcategory__a-apply-text-field">
                    <a-apply-text-field
                      id="t-announcements-add__fields__pushcategory__a-apply-text-field-id"
                      v-model="announcementData.pushCategory"
                      data-testid="add-announcement-pushcategory"
                      type="text"
                      maxlength="10"
                      placeholder="テキストを入力"
                      maxlength-id="t-announcements-add-pushcategory-count"
                    />
                  </div>
                </m-form-input>
              </div>
              <o-push-segment-type 
                v-if="pushStatus === 'limited'" 
                id="announcements-add-segment-type"
                v-model="announcementData.pushSegmentType"
                data-testid="add-announcements-segment-type"
                @change="handleSegmentTypeChange"
              />
              <o-push-segment-selection
                v-if="pushStatus === 'limited' && announcementData.pushSegmentType === 'selection'"
                id="announcements-add-segment-selection"
                v-model="announcementData.pushSegmentSelectionInfo"
                data-testid="add-announcements-segment-selection"
              />
              <div
                v-if="pushStatus === 'limited' && announcementData.pushSegmentType === 'csv'"
                id="t-announcements-add__fields__upload-file"
                class="t-announcements-add__fields__upload-file"
              >
                <a-text id="t-announcements-add__fields__a-text-top_3">●</a-text>
                <a-text id="t-announcements-add__fields__upload-file__a-text">CSVアップロード</a-text>
                <o-csv-uploader
                  v-model:push-target-list-file="announcementData.pushTargetListFile"
                  v-model:push-target-list-file-type="announcementData.pushTargetListFileType"
                  :error-function="showErrorModal"
                />
              </div>
            </m-action-card>
          </m-section>
          <m-section>
            <m-action-card :id="idName[1]" title="内容サマリ" header-border no-header-margin icon="clock">
              <div class="t-announcements-add__fields">
                <div id="t-announcements-add-uploading-file" class="t-announcements-add__row">
                  <div class="t-announcements-add__col-1">
                    <div class="t-announcements-add__fields">
                      <!-- .jfifと.svg対応はチケット#6297で対応予定 -->
                      <!-- <m-form-input>
                        <a-upload-field
                          id="t-announcements-add-upload-image"
                          v-model="announcementData.imageFile.file"
                          name="imageFile"
                          class="t-announcements-add-uploading-file__form-upload"
                          label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                          accept="image/png, .jfif, image/jpg, image/jpeg, .svg"
                          @change="handleUploadFileChangeImg(announcementData.imageFile)"
                          @showErrorModal="showErrorModal"
                        />
                      </m-form-input> -->
                      <m-form-input>
                        <a-upload-field
                          id="t-announcements-add-upload-image"
                          v-model="announcementData.imageFile.file"
                          test-id-text="add-announcement-summary-image"
                          name="imageFile"
                          class="t-announcements-add-uploading-file__form-upload"
                          label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                          accept="image/png, image/jpg, image/jpeg"
                          @change="handleUploadFileChangeImg(announcementData.imageFile)"
                          @show-error-modal="showErrorModal"
                        />
                      </m-form-input>
                    </div>
                  </div>
                  <div class="t-announcements-add__col-2">
                    <div class="t-announcements-add__fields">
                      <m-form-input>
                        <a-apply-text-field
                          id="title"
                          v-model="announcementData.title"
                          data-testid="add-announcement-summary-title-input"
                          type="text"
                          maxlength="16"
                          placeholder="タイトル入力"
                          maxlength-id="add-announcement-add-title-maxlength"
                        />
                      </m-form-input>
                      <m-form-input>
                        <a-apply-text-field
                          v-model="announcementData.text"
                          data-testid="add-announcement-summary-content-input"
                          class="t-announcements-add__content-input"
                          type="textarea"
                          rows="2"
                          maxlength="35"
                          placeholder="テキスト入力"
                          maxlength-id="add-announcement-add-text-maxlength"
                        />
                      </m-form-input>
                    </div>
                  </div>
                </div>
              </div>
            </m-action-card>
          </m-section>
          <m-section>
            <m-action-card :id="idName[2]" title="詳細ページ内容" header-border no-header-margin icon="clock-remove">
              <div class="t-announcements-add__fields">
                <div id="t-announcements-add-info-uploading-file" class="t-announcements-add__row">
                  <div class="t-announcements-add__col-1">
                    <div class="t-announcements-add__fields">
                      <!-- .jfifと.svg対応はチケット#6297で対応予定 -->
                      <!-- <m-form-input>
                        <a-upload-field
                          id="t-announcements-add-info-upload-image"
                          v-model="announcementData.detailInfo.imageFile.file"
                          class="t-announcements-add-uploading-file__form-upload"
                          label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                          accept="image/png, .jfif, image/jpg, image/jpeg, .svg"
                          @change="handleUploadFileChangeImg(announcementData.detailInfo.imageFile)"
                          @showErrorModal="showErrorModal"
                        />
                      </m-form-input> -->
                      <m-form-input>
                        <a-upload-field
                          id="t-announcements-add-info-upload-image"
                          v-model="announcementData.detailInfo.imageFile.file"
                          test-id-text="add-announcement-detail-image"
                          class="t-announcements-add-uploading-file__form-upload"
                          label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                          accept="image/png, image/jpg, image/jpeg"
                          @change="handleUploadFileChangeImg(announcementData.detailInfo.imageFile)"
                          @show-error-modal="showErrorModal"
                        />
                      </m-form-input>
                    </div>
                  </div>
                  <div class="t-announcements-add__col-2">
                    <div class="t-announcements-add__fields">
                      <m-form-input>
                        <a-apply-text-field
                          id="t-announcements-add-info-title"
                          v-model="announcementData.detailInfo.title"
                          data-testid="add-announcement-detail-title-input"
                          type="text"
                          maxlength="50"
                          placeholder="タイトル入力"
                          maxlength-id="add-announcement-add-detail-title-maxlength"
                        />
                      </m-form-input>
                      <m-rich-text-editor
                        id="htmlContent"
                        :html-content="announcementData.detailInfo.htmlContent"
                        max-length="800"
                        @get-html-content="announcementData.detailInfo.htmlContent = $event"
                        @get-text="announcementData.detailInfo.text = $event"
                      />
                    </div>
                  </div>
                </div>
                <o-transition-type-service
                  v-model:transition-type="announcementData.detailInfo.transitionType"
                  v-model:transition-doc="announcementData.detailInfo.transitionDoc"
                  v-model:contents-url="announcementData.detailInfo.contentsURL"
                />
                <div v-if="announcementData.detailInfo.transitionType === 'url'" class="t-announcements-add__fields">
                  <m-form-input id="t-announcements-add-info-webviewFlag__form-input">
                    <a-text id="t-announcements-add-info-webviewFlag__a-text">Webビュー</a-text>　　
                    <a-switch
                      id="t-announcements-add-webviewFlag"
                      v-model="announcementData.detailInfo.webviewFlag"
                      data-testid="add-announcement-detail-webview-toggle-button"
                    />
                    <a-text id="t-announcements-add-info-webview-note__a-text"
                      >※Webビュー設定ONの場合、URLにはダイナミックリンクを登録しないでください。</a-text
                    >
                  </m-form-input>
                </div>
                <div v-if="announcementData.detailInfo.transitionType === 'url'" class="t-announcements-add__fields">
                  <m-form-input id="t-announcements-add-info-dAccountLoginFlag__form-input">
                    <a-text id="t-announcements-add-info-dAccountLoginFlag__a-text"
                      >ビジネスｄアカウントログイン</a-text
                    >
                    <a-switch
                      id="t-announcements-add-dAccountLoginFlag"
                      v-model="announcementData.detailInfo.dAccountLoginFlag"
                      data-testid="add-announcements-detail-webview-toggle-button"
                    />
                  </m-form-input>
                </div>
              </div>
            </m-action-card>
          </m-section>
          <m-section>
            <m-action-card :id="idName[3]" title="公開設定" header-border no-header-margin icon="calendar-setting">
              <div class="t-announcements-add__fields">
                <div id="t-announcements-add-cast-start-date-day__row" class="t-announcements-add__row">
                  <a-text id="t-announcements-add-cast-start-date__a-text">公開日</a-text>　
                  <m-form-input id="t-announcements-add-cast-start-date-day__form-input">
                    <a-calendar-field
                      id="cast-start-date-day"
                      v-model="announcementData.castStartDate"
                      test-id-text="add-announcement-publish-start"
                      :min-date="minDate"
                      mode="dateTime"
                    />
                  </m-form-input>
                </div>
                <div class="t-announcements-add__row">
                  <a-text id="t-announcements-add-cast-end-date__a-text">公開終了日</a-text>　
                  <m-form-input id="t-announcements-add-cast-end-date-day__form-input">
                    <a-calendar-field
                      id="cast-end-date-day"
                      v-model="announcementData.castEndDate"
                      test-id-text="add-announcement-publish-end"
                      :min-date="minDate"
                      mode="dateTime"
                      @change="handleChange"
                    />
                  </m-form-input>
                </div>
              </div>
            </m-action-card>
          </m-section>
          <m-section>
            <m-action-card :id="idName[4]" title="承認フロー" header-border no-header-margin icon="user-setting">
              <div class="t-announcements-add__fields__pushtype">
                <m-form-input id="t-announcements-add__fields__pushtype_2">
                  <a-select-field
                    id="t-announcement-add__fields__pushtype__a-select-field"
                    v-model="announcementData.checkStatus"
                    data-testid="add-announcement-check-status-select"
                    :options="checkStatusOptions"
                    disabled="true"
                  />
                </m-form-input>
              </div>
            </m-action-card>
          </m-section>
        </div>
        <m-form-action-buttons>
          <a-button
            id="saveBtn"
            data-testid="add-announcement-save-button"
            variant="block"
            color="primary"
            :disabled="disabledButton"
            submit="submit"
            >保存</a-button
          >
        </m-form-action-buttons>
      </form>
    </div>
    <!-- Info, Erro Modal -->
    <teleport to="body">
      <o-modal
        id="announcementsCreate_resultModal"
        :visible="resultModalVisible"
        class="o-modal--confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span id="announcementsCreate_resultModal_body" v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            data-testid="error-info-modal-confirm-button"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleCloseModal"
          />
        </template>
      </o-modal>
    </teleport>
  </t-default-layout>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';
import ASwitch from '@/components/atoms/switch';
import AUploadField from '@/components/atoms/upload-field';
import AText from '@/components/atoms/text';
import ABackPage from '@/components/atoms/back-page';
import AApplyTextField from '@/components/atoms/apply-text-field';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import TDefaultLayout from '@/components/templates/default-layout';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import MFormInput from '@/components/molecules/form-input';
import ASelectField from '@/components/atoms/select-field';
import OTransitionTypeService from '@/components/organisms/transition-type-service';
import OModal from '@/components/organisms/modal';
import OCsvUploader from '@/components/organisms/csv-uploader/index.vue';
import ACalendarField from '@/components/atoms/calendar-field';
import { utils } from '@/common/utils.js';
import { useVuelidate } from '@vuelidate/core';
import { announcementValidation } from '@/validations/announcement.js';
import { cloneDeep } from 'lodash';
import MRichTextEditor from '@/components/molecules/rich-text-editor';
import OPushSegmentType from '@/components/organisms/push-segment-type';
import OPushSegmentSelection from '@/components/organisms/push-segment-selection';
import { buildPushSegmentSelectionForSave } from '@/common/pushSegmentConvert';

export default {
  name: 't-announcements-add',
  components: {
    TDefaultLayout,
    MSection,
    MActionCard,
    AText,
    AButton,
    ABackPage,
    MFormActionButtons,
    ASwitch,
    MFormInput,
    ASelectField,
    OModal,
    OCsvUploader,
    AUploadField,
    ACalendarField,
    AApplyTextField,
    MRichTextEditor,
    OTransitionTypeService,
    OPushSegmentType,
    OPushSegmentSelection
  },
  mixins: [customRequest, customValidate, messageContent, utils],
  props: {
    class: {
      type: String,
      default: '',
    },
  },

  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  data() {
    return {
      idName: [],
      minDate: utils.currentDateTime(),
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      disabledButton: null,

      //お知らせデータ
      announcementData: {
        pushFlag: false, //push 通知フラグ
        text: '', //お知らせ内容
        title: '', //お知らせタイトル
        imageURL: '', //
        imageFile: {
          file: null,
          filename: null,
          binary: null,
          size: null,
        },
        importantFlag: false, //重要なお知らせフラグ
        castStartDate: '', //公開開始日
        castEndDate: '', //公開終了日
        deleteDate: '', //削除予定日
        draftFlag: true, //下書き
        checkStatus: 'draft', //作成時のチェックステータスは下書き
        detailInfo: {
          //お知らせ詳細
          text: '',
          title: '',
          contentsURL: '',
          webviewFlag: false, //Webビューフラグ
          contentsFile: {
            file: null,
            filename: null,
            binary: null,
            size: null,
          },
          imageURL: '',
          imageFile: {
            file: null,
            filename: null,
            binary: null,
            size: null,
          },
          transitionType: 'url', //遷移先種別
          transitionDoc: '', //遷移先ドキュメントID
          dAccountLoginFlag: false, //ビジネスｄアカウントログイン
        },
        pushType: 'ALL',
        pushTargetListFile: {
          file: null,
          filename: null,
          binary: null,
          size: null,
        },
        pushTargetListFileType: 'accountid',
        pushCategory: 'サービス',
        pushNotificationCategory: 'announcement',
        pushSegmentType: 'selection',
        pushSegmentSelectionInfo: {
          loginFlag: true,
          accountTypes: [],
          industries: [],
          employeeCounts: [],
        }
      },
      pushStatus: 'none',
      pushStatusOptions: [
        { value: 'all', label: '配信可能な全ユーザー' },
        { value: 'limited', label: '特定プッシュ通知' },
        { value: 'none', label: 'プッシュ通知なし' },
      ],
      pushNotificationCategoryOptions: [
        { value: 'point', label: 'ポイント通知' },
        { value: 'announcement', label: 'お知らせ（お得な情報・新機能等）' },
      ],
      checkStatusOptions: [
        { value: 'draft', label: '下書き' },
        { value: 'checked', label: 'チェック済み' },
        { value: 'approved', label: '承認済み' },
      ],
    };
  },

    validations() {
      return announcementValidation.create(
        this.announcementData,
        this.announcementData.checkStatus
      );
    },

  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-announcements-add');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  created() {
    for (let i = 0; i <= 4; i++) {
      this.idName[i] = 'h1-announcements-add-' + i;
    }
  },
  methods: {
    async handleFormSubmit() {
      const isFormCorrect = await this.v$.$validate();

      if (!isFormCorrect) {
        let errMsg = '';
        this.v$.$errors.map(item => (errMsg += item.$message + '<br>'));
        this.showErrorModal(errMsg);
        return;
      }

      const payload = cloneDeep(this.announcementData);

      const htmlContent = payload.detailInfo.htmlContent;
      const hasError = messageContent.validateHtmlContentUrls(htmlContent, this.showErrorModal, messageContent.urlSpecialCharater);
      if (hasError) {
        return;
      }
      // URLに特殊文字　<>'"　を入力するチェックする
      if (messageContent.checkUrlSpecialCharacter(payload.detailInfo.contentsURL)) {
        this.showErrorModal(messageContent.urlSpecialCharater);
        return;
      }
      payload.detailInfo.contentsURL = encodeURI(payload.detailInfo.contentsURL);
      // Note: 「=」はCloudArmorポリシーに抵触するケースがあるためエスケープを行う
      payload.title = payload.title.replace(/=/g, '%%eq%%');
      payload.text = payload.text.replace(/=/g, '%%eq%%');
      payload.detailInfo.title = payload.detailInfo.title.replace(/=/g, '%%eq%%');
      payload.detailInfo.text = payload.detailInfo.text.replace(/=/g, '%%eq%%');

      // Note: htmlコンテンツは不要なタグの削除
      payload.detailInfo.htmlContent = utils.processHtmlContent(payload.detailInfo.htmlContent);
  
      if (!messageContent.checkHasSpecialCharacterInObj(payload)) {
        this.showErrorModal(messageContent.hasSpecialCharacter);
        return;
      }

      if (this.announcementData.castEndDate) {
        const castEndDate = new Date(this.announcementData.castEndDate);
        const deleteDate = new Date(castEndDate.setFullYear(castEndDate.getFullYear() + 1));
        this.deleteDate = this.convertDateToString(deleteDate);
      }

      // 特定プッシュ通知以外はファイルクリア
      if (this.pushStatus !== 'limited' || this.announcementData.pushSegmentType === 'selection') {
        this.announcementData.pushTargetListFile.filename = null;
        this.announcementData.pushTargetListFile.binary = null;
        this.announcementData.pushTargetListFile.size = null;
      }

      // 通知ステータスの状態を反映
      switch (this.pushStatus) {
        case 'all': {
          this.announcementData.pushFlag = true;
          this.announcementData.pushType = 'ALL';
          break;
        }
        case 'limited': {
          this.announcementData.pushFlag = true;
          this.announcementData.pushType = 'Limited';
          break;
        }
        case 'none': {
          this.announcementData.pushFlag = false;
          this.announcementData.pushType = 'ALL';
          break;
        }
        default: {
          this.announcementData.pushFlag = false;
          this.announcementData.pushType = 'ALL';
        }
      }
      const formDataTmp = {
        text: payload.text ?? '',
        title: payload.title ?? '',
        imageFile: this.announcementData.imageFile.binary ?? '',
        pushFlag: this.announcementData.pushFlag ?? false,
        importantFlag: this.announcementData.importantFlag ?? false,
        castStartDate: this.announcementData.castStartDate ?? '',
        castEndDate: this.announcementData.castEndDate ?? '',
        deleteDate: this.deleteDate ?? '',
        draftFlag: this.announcementData.draftFlag ?? false,
        checkStatus: this.announcementData.checkStatus ?? '',
        userList: '',
        imageURL: this.announcementData.imageURL ?? '',
        pushDoneCount: 0,
        detailInfo: {
          text: payload.detailInfo.text ?? '',
          title: payload.detailInfo.title ?? '',
          htmlContent: payload.detailInfo.htmlContent ?? '',
          imageFile: this.announcementData.detailInfo.imageFile.binary ?? '',
          imageURL: this.announcementData.detailInfo.imageURL ?? '',
          contentsURL: encodeURI(this.announcementData.detailInfo.contentsURL.replace(/[\s\uFEFF\xA0]/g, '')) ?? '',
          webviewFlag: this.announcementData.detailInfo.webviewFlag ?? false,
          transitionType: this.announcementData.detailInfo.transitionType ?? 'url',
          transitionDoc: this.announcementData.detailInfo.transitionDoc ?? '',
          dAccountLoginFlag: this.announcementData.detailInfo.dAccountLoginFlag ?? false,
        },
        pushType: this.announcementData.pushType ?? 'ALL',
        pushNotificationCategory: this.announcementData.pushNotificationCategory ?? '',
        pushTargetListFile: this.announcementData.pushTargetListFile.binary ?? '',
        pushTargetListFileSize: this.announcementData.pushTargetListFile.size ?? 0,
        pushTargetListFileName: this.announcementData.pushTargetListFile.filename ?? '',
        pushTargetListFileType: this.announcementData.pushTargetListFileType ?? 'accountid',
        pushCategory: this.announcementData.pushCategory ?? '',
        pushSegmentType: this.announcementData.pushSegmentType ?? 'selection',
        pushSegmentSelectionInfo: buildPushSegmentSelectionForSave(this.pushStatus, this.announcementData),
      };

      this.disabledButton = 'disabled';

      await this.postRequest('/announcements/add', formDataTmp).then(res => {
        if (res.status === 'success') {
          this.$router.push({ name: 'Announcements' });
        } else {
          if (res.message) {
            this.showErrorModal(res.message);
          } else {
            this.showErrorModal(messageContent.requireTry('お知らせ作成'));
          }
        }
        this.disabledButton = null;
      });
    },
    handleSegmentTypeChange(newType) {
      if (newType === 'csv') {
        this.announcementData.pushSegmentSelectionInfo = {
          loginFlag: true,
          accountTypes: [],
          industries: [],
          employeeCounts: [],
        };
      } else if (newType === 'selection') {
        this.announcementData.pushTargetListFile.filename = null;
        this.announcementData.pushTargetListFile.binary = null;
        this.announcementData.pushTargetListFile.size = null;
      }
    },
    handleUploadFileChangeImg(fileObj) {
      const vm = this;
      const reader = new FileReader();
      reader.addEventListener(
        'load',
        function () {
          // eslint-disable-next-line no-unused-vars
          const [info, content] = reader.result.split(',');
          fileObj.binary = content;
        },
        false
      );
      if (fileObj.file[0]) {
        reader.readAsDataURL(fileObj.file[0]);
        fileObj.filename = fileObj.file[0].name;
        fileObj.size = fileObj.file[0].size;
        if (fileObj.filename !== null) {
          vm.agree = true;
        }
      } else {
        // clear file content
        fileObj.file = null;
        fileObj.filename = null;
        fileObj.binary = null;
        fileObj.size = null;
        vm.agree = false;
      }
    },
    handleChange() {},
    handleCancelClick() {
      this.$router.push({ name: 'Announcements' });
    },

    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    checkDefaultCategory() {
      if (this.announcementData.importantFlag && this.announcementData.pushCategory === 'サービス') {
        this.announcementData.pushCategory = '重要';
      } else if (!this.announcementData.importantFlag && this.announcementData.pushCategory === '重要') {
        this.announcementData.pushCategory = 'サービス';
      }
    },
  },
};
</script>
